// extracted by mini-css-extract-plugin
export default {"root":"Navigation_root__f4EUp","item":"Navigation_item__0SLsO","current":"Navigation_current__UKlsk","badge":"Navigation_badge__lEqpS"};